import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  AppBar,
  Toolbar,
  Typography
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonIcon from "@mui/icons-material/Person";
import speedLogo from "./images/speedlogo.png";


const menuData = [
  {
    title: "Products",
    items: [
      { name: "AI Agents", link: "/aiagents" },
      { name: "Digital Resources Management", link: "/digitalassets" },
      { name: 'Ecommerce', link: '/ecommerce' },

    ],
  },
  {
    title: "Services",
    items: [
      { name: "POS & Systems", link: "/possys" },
      { name: "Network Hardware", link: "/networks" },
      { name: "Wireless & Site Surveys", link: "/wifi" },
      { name: "Structured Cabling", link: "/ethernet" },

    ],
  },
  {
    title: "About",
    items: [
      { name: "Company", link: "/about/company" },
      { name: "Team", link: "/about/team" },
    ],
  },
  {
    title: "Contact",
    items: [
      { name: "Let's Talk", link: "/bookit" },
      { name: "Support", link: "/contact/support" },

    ],
  },
];

const MenuComponent = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMenuOpen = (event, title) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(title);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentMenu(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AppBar position="sticky" sx={{ bgcolor: "#ffffffff", boxShadow: 0, }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Box display="flex" alignItems="center"
          sx={{



          }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <img
              src={speedLogo}
              alt="logo"
              width="60px"
              height="60px"
              style={{
                cursor: "pointer",
                filter: "drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.15))"
              }}
            />
          </Link>

          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              ml: 0,
              color: "black",
              fontStyle: "italic"
            }}
          >
            Data Speedway
          </Typography>
        </Box>


        {/* Desktop Menu (Hidden on Mobile) */}
        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
          {menuData.map((menu, index) => (
            <Box key={index} sx={{ mx: 2 }}>
              <Button
                onClick={(e) => handleMenuOpen(e, menu.title)}
                endIcon={<ArrowDropDownIcon />}
                sx={{ color: "text.primary", textTransform: "none", fontSize: "1.2rem", fontWeight: 600 }}
              >
                {menu.title}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={currentMenu === menu.title}
                onClose={handleMenuClose}
                PaperProps={{ sx: { mt: 1, border: "1px solid #ddd", borderRadius: 2 } }}
              >
                {menu.items.map((item, i) => (
                  <MenuItem
                    key={i}
                    component={Link}
                    to={item.link}
                    onClick={handleMenuClose}
                    sx={{ color: "text.primary", fontSize: "1.1rem" }}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ))}
        </Box>

        {/* Profile Icon */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton component={Link} to="/login">
            <PersonIcon fontSize="medium" sx={{ color: 'black' }} />
          </IconButton>

          {/* Mobile Menu Icon (Hidden on Desktop) */}
          <IconButton
            sx={{ display: { xs: "flex", md: "none" }, ml: 2 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon fontSize="large" sx={{ color: 'black' }} />
          </IconButton>
        </Box>
      </Toolbar>

      {/* Mobile Drawer Menu */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { xs: "flex", md: "none" } }}
      >
        <Box sx={{ width: 250 }}>
          <List>
            {menuData.map((menu, index) => (
              <React.Fragment key={index}>
                <ListItem>
                  <ListItemText primary={menu.title} sx={{ fontWeight: "bold" }} />
                </ListItem>
                {menu.items.map((item, i) => (
                  <ListItem button key={i} component={Link} to={item.link} onClick={handleDrawerToggle}>
                    <ListItemText primary={item.name} />
                  </ListItem>
                ))}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default MenuComponent;
